/**
 * Single M List listing card. Twentytwentysix styling.
 * Square image; click opens detail modal. tagIdToTag: optional map when API returns tag IDs.
 */
import React, {useState} from "react";
import MListListingDetailModal from "./MListListingDetailModal";

function getTagLabel(t, tagIdToTag = {}) {
    if (t && typeof t === "object" && (t.name || t.slug)) return {
        key: t.id ?? t.slug ?? t.name,
        label: t.name ?? t.slug
    };
    const resolved = tagIdToTag[t];
    if (resolved) return {key: resolved.id, label: resolved.name ?? resolved.slug};
    return null;
}

export default function MListListingCard({entry, tagIdToTag = {}}) {
    const [detailOpen, setDetailOpen] = useState(false);

    if (!entry) return null;
    const name = entry.business_name ?? "Listing";
    const tagLabels = (entry.tags || []).map((t) => getTagLabel(t, tagIdToTag)).filter(Boolean);

    return (
        <>
            <li className="twentytwentysix-content__listing-card">
                <button
                    type="button"
                    className="twentytwentysix-content__listing-card-inner"
                    onClick={() => setDetailOpen(true)}
                    aria-label={`View details for ${name}`}
                >
                    <div className="twentytwentysix-content__listing-image-wrap">
                        {entry.graphic_400 ? (
                            <div className="twentytwentysix-content__listing-image-media">
                                <img
                                    src={entry.graphic_400}
                                    alt={name}
                                    className="twentytwentysix-content__listing-image"
                                />
                            </div>
                        ) : (
                            <div
                                className="twentytwentysix-content__listing-image-placeholder"
                                aria-hidden="true"
                            />
                        )}
                    </div>
                    <div className="twentytwentysix-content__listing-body">
                        <strong className="twentytwentysix-content__listing-name">{name}</strong>
                        {entry.heart_count != null && entry.heart_count > 0 && (
                            <span className="twentytwentysix-content__listing-hearts"
                                  aria-label={`${entry.heart_count} recommendations`}>
                ♥ {entry.heart_count}
              </span>
                        )}
                        {entry.short_description && (
                            <p className="twentytwentysix-content__listing-desc">{entry.short_description}</p>
                        )}
                        {tagLabels.length > 0 && (
                            <div className="twentytwentysix-content__listing-tags">
                                {tagLabels.map(({key, label}) => (
                                    <span key={key} className="twentytwentysix-content__listing-tag">
                    {label}
                  </span>
                                ))}
                            </div>
                        )}
                        {(entry.website || entry.instagram_name || entry.phone) && (
                            <div className="twentytwentysix-content__listing-meta">
                                {entry.website && (
                                    <a href={entry.website.startsWith("http") ? entry.website : `https://${entry.website}`}
                                       target="_blank" rel="noopener noreferrer"
                                       className="twentytwentysix-content__link" onClick={(e) => e.stopPropagation()}>
                                        Website
                                    </a>
                                )}
                                {entry.instagram_name && (
                                    <a href={`https://instagram.com/${entry.instagram_name.replace(/^@/, "")}`}
                                       target="_blank" rel="noopener noreferrer"
                                       className="twentytwentysix-content__link" onClick={(e) => e.stopPropagation()}>
                                        @{entry.instagram_name.replace(/^@/, "")}
                                    </a>
                                )}
                                {entry.phone &&
                                    <span className="twentytwentysix-content__listing-phone">{entry.phone}</span>}
                            </div>
                        )}
                    </div>
                </button>
            </li>

            {detailOpen && (
                <MListListingDetailModal
                    entry={entry}
                    tagIdToTag={tagIdToTag}
                    onClose={() => setDetailOpen(false)}
                />
            )}
        </>
    );
}
